export const dateFormats = [
  { name: 'DD/MM/YYYY', format: 'DD MMM, YYYY' },
  { name: 'MM/DD/YYYY', format: 'MMM DD, YYYY' },
  { name: 'YYYY/MM/DD', format: 'YYYY, MMM DD' }
]

export const timeFormat = {
  h24: 'HH:mm',
  AMPM: 'hh:mm A'
}

export const timeFormats = [
  { name: 'AM/PM', format: timeFormat.AMPM },
  { name: '24 Hours', format: timeFormat.h24 }
]